import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
// eslint-disable-next-line react/display-name
export const withRouter = (component) => () => (_jsx(BrowserRouter, { children: _jsx(Suspense, { fallback: "Loading...", children: component() }) }));
